<template>
    <div class="plus_div">
        <TitleBackground></TitleBackground>
        <PlusAll></PlusAll>
    </div>
</template>
<script type="text/javascript">
import TitleBackground from './sub_components/title.vue'
import PlusAll from './sub_components/plus_all.vue'

export default {
    components: {
        TitleBackground,
        PlusAll
    }
}

</script>
<style type="text/css" scoped>

</style>
